<template>
  <customFieldsAddingPreview
    :icon='"at.svg"'
    :name="preloadedItem.name || 'Email'">

    <template :slot='"body"'>
      <v-text-field
        v-model="value"
        :rules="emailRules"
        :placeholder="preloadedItem.placeholder || ''"
        pt="5"
        class="r-field item-name-field custom-field-email"/>
    </template>
  </customFieldsAddingPreview>
</template>

<script>
import customFieldsAddingPreview from '../customFieldsAddingPreview'
export default {
  props: {
    preloadedItem: {
      type: Object,
      default: () => {
        return {
          name: '',
          placeholder: '',
          defaultValue: null
        }
      }
    }
  },
  data: function() {
    return {
      value: this.preloadedItem.defaultValue,
      emailRules: [
        (v) => {
          if (v?.length) {
            const reg = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i)
            return reg.test(v) || 'Email must be valid'
          }
          return true
        }],
      phoneRules: [v => { return true }]
    }
  },
  watch: {
    'preloadedItem.defaultValue': {
      handler (newDefaultValue, oldDefaultValue) {
        if (this.value === oldDefaultValue) {
          this.value = newDefaultValue
        }
      },
      deep: true
    }
  },
  components: {
    customFieldsAddingPreview
  }
}
</script>
